const ReactDOM = require('react-dom');

exports.replaceHydrateFunction = () => ReactDOM.render;
exports.onClientEntry = () => {
  if (!('fetch' in window)) {
    require('whatwg-fetch'); //eslint-disable-line
  }
};
